import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../images/circle-info-regular-full.svg'

function KeywordDescription ({ descriptionLocal, setDescriptionLocal }) {
  const handleDescriptionChange = e => {
    const { name, value } = e.target
    setDescriptionLocal(prev => ({
      ...prev,
      [name]: value
    }))
  }

  return (
    <section className={styles.keywordDescriptionSection}>
      <div className={styles.keywordDescriptionContainer}>
        <div className={styles.keywordDescriptionColumn}>
          <div className={styles.labelWithIcon}>
            <label className={styles.KeywordDescriptionLabel} htmlFor='value'>
              Description
            </label>
            <Tooltip
              title='Filter by words in the property description.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Description help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <input
            placeholder='Keyword'
            className={styles.KeywordDescriptionInput}
            type='text'
            id='value'
            name='value'
            autoComplete='off'
            value={descriptionLocal?.value || ''}
            onChange={handleDescriptionChange}
          />
        </div>
      </div>
    </section>
  )
}

export default KeywordDescription
